export enum EEmirNotifications {
  CREATE = 'create-command',
  UPDATE = 'update-command',
  DELETE = 'delete-commands',
}

export enum EAARNotifications {
  ADD = 'add-arr',
  BULK_DELETE = 'bulk_delete-arr',
}

export enum EPistNotifications {
  ADD = 'add-pist',
  LOAD = 'cp-pist',
  BULK_DELETE = 'bulk_delete-pist',
}

export enum EDugumNotificaions {
  ADD = 'add-dugum',
  BULK_DELETE = 'bulk_delete-node',
}

export enum EYolNotifications {
  ADD = 'add-yol',
  LOAD = 'cp-yol',
  BULK_DELETE = 'bulk_delete-yol',
}

export enum ECheckpointNotifications {
  LOAD_INITIATED = 'load-initiated-checkpoint',
  ADD = 'add-checkpoint',
  LOAD = 'load-checkpoint',
  BULK_DELETE = 'bulk_delete-checkpoint',
}

export enum EEtmenNotifications {
  ADD = 'add-agent',
  BULK_DELETE = 'bulk_delete-agent',
}

export enum EEtmenTuruNotifications {
  ADD = 'add-agent_prototype',
  BULK_DELETE = 'bulk_delete-agent_prototype',
}

export enum ECevreselEtmenNotifications {
  ADD = 'add-env_agent',
  BULK_DELETE = 'bulk_delete-env_agent',
}

export enum ENizamNotifications {
  ADD = 'add-formation',
  UPDATE = 'update-formation',
  BULK_DELETE = 'bulk_delete-formation',
  DELETE = 'delete-formation',
}

export enum EVeritabaniNotifications {
  SABITLER = 'sabitler',
}
